import axios from "axios";
import { toast } from "react-toastify";
import { logoutUser } from "../Services/authService";

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_LACIVERT_API_ENDPOINT,
});

apiClient.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("accessToken") || localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    toast.error("İstek gönderilirken bir ağ hatası oluştu.");
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      axios.isCancel(error) ||
      error.code === "ERR_CANCELED" ||
      error.name === "AbortError" ||
      error.name === "CanceledError"
    ) {
      return Promise.reject(error);
    }

    if (error.response) {
      if (error.response.status === 401) {
        toast.error(
          "Oturum süreniz doldu veya yetkiniz yok. Lütfen tekrar giriş yapın.",
        );
        logoutUser();
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      } else if (error.response.status === 403) {
        toast.error("Bu işlemi yapmak için yetkiniz bulunmamaktadır.");
      } else if (error.response.status >= 500) {
        toast.error("Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.");
      }
    } else if (error.request) {
      toast.error(
        "Sunucudan yanıt alınamadı. Lütfen ağ bağlantınızı kontrol edin.",
      );
    } else {
      toast.error("İstek hazırlanırken bir hata oluştu.");
    }
    return Promise.reject(error);
  },
);
